var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"masthead"},[_c('svg-moovup-logo',{staticClass:"masthead__logo"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }